import React, { useState } from 'react';
import AdSpaceOwnerPackagesAdminList from './components/AdSpaceOwnerPackagesAdminList';
import AdSpaceOwnerPackagesAdminAddOwnerPackagePage from './components/AdSpaceOwnerPackagesAdminAddOwnerPackagePage';
import { Box, Tabs, Tab } from '@mui/material';



const AdSpaceMediaTypesAdminPage: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="AdSpaces admin tabs">
        <Tab label="List adSpace Owner packages" />
        <Tab label="Insert adSpace Owner package" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <AdSpaceOwnerPackagesAdminList />}
        {tab === 1 && <AdSpaceOwnerPackagesAdminAddOwnerPackagePage />}
      </Box>
    </Box>
  );
};

export default AdSpaceMediaTypesAdminPage;